import ErrorBoundary from '@components/ErrorBoundary';
import FeatureFlagFAB from '@components/FeatureFlagFAB';
import Spinner from '@components/Spinner';
import useLogin from '@hooks/useLogin';
import useMobileCookieTokenAuth from '@hooks/useMobileCookieTokenAuth';
import { Suspense, useEffect, useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import DefaultLayout from 'src/layouts/MexPortalSideBarLayout';
import WithUpdateWorker from 'src/utils/update-worker/WithUpdateWorker';
import { useUserProfile } from '@hooks/useUserProfile';
import { datadogRum } from '@datadog/browser-rum';
import { isProdEnv } from 'src/utils';

const AppContent = () => {
  // Initialize user profile data early in the app lifecycle
  const { apiData, isLoading } = useUserProfile();

  // Track if Datadog user has been set to ensure it's only called once
  const datadogUserSetRef = useRef(false);

  // Set Datadog user when profile data is available (only once)
  useEffect(() => {
    if (!isLoading && apiData && !datadogUserSetRef.current && typeof datadogRum?.setUser === 'function') {
      const userData = {
        id: apiData?.user_profile?.username || apiData?.user_profile?.grab_id || 'unknown',
        role: apiData?.user_profile?.role || 'unknown',
      };

      datadogRum.setUser(userData);
      datadogUserSetRef.current = true; // Mark as set to prevent future calls
    }
  }, [isLoading, apiData]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route path="/*" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
      {!isProdEnv() && <FeatureFlagFAB />}
    </ErrorBoundary>
  );
};

const App = () => {
  const { isReady: isMobileCookieTokenAuthReady } = useMobileCookieTokenAuth();

  useLogin(isMobileCookieTokenAuthReady);

  if (!isMobileCookieTokenAuthReady) {
    return <Spinner />;
  }

  return <AppContent />;
};

export default WithUpdateWorker(App);
